import { render, staticRenderFns } from "./ClassifyAndNav.vue?vue&type=template&id=1d86883f&scoped=true"
import script from "./ClassifyAndNav.vue?vue&type=script&lang=js"
export * from "./ClassifyAndNav.vue?vue&type=script&lang=js"
import style0 from "./ClassifyAndNav.vue?vue&type=style&index=0&id=1d86883f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d86883f",
  null
  
)

export default component.exports